import ConditionLayoutProductProvider from './hooks/useConditionLayoutProduct';

import { ConditionLayoutProductProps } from './@types/ConditionLayoutProductProps';
import ConditionLayoutProductContainer from './handles/ConditionLayoutProductContainer';

const ConditionLayoutProduct = (props: ConditionLayoutProductProps) => (
	<ConditionLayoutProductProvider {...props}>
		<ConditionLayoutProductContainer>{props.children}</ConditionLayoutProductContainer>
	</ConditionLayoutProductProvider>
);

export default ConditionLayoutProduct;
